module.exports = __webpack_public_path__ + "static/media/in.d6fe1a1e.svg";